// ABOUTME: Custom shirt/clothing SVG icon for fashion-related UI elements.
// ABOUTME: Matches Heroicons outline style (24x24, stroke 1.5, round caps/joins).

export function ShirtIcon(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth={1.5}
      strokeLinecap="round"
      strokeLinejoin="round"
      aria-hidden="true"
      {...props}
    >
      <path d="M20.38 3.46 16 2 13.5 5.5a1.5 1.5 0 0 1-3 0L8 2 3.62 3.46a2 2 0 0 0-1.34 1.78L2 17.5a1 1 0 0 0 1 1h4.5l.71-10.2L10 7.5V22h4V7.5l1.79 1.8L16.5 18.5H21a1 1 0 0 0 1-1l-.28-12.26a2 2 0 0 0-1.34-1.78z" />
    </svg>
  )
}
